import React, { useEffect, useState } from 'react';
import { ShieldAlert, X } from 'lucide-react';

export const RateLimitToast: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    const handleRateLimit = () => {
      setIsVisible(true);
      // Auto-hide after 5 seconds
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };

    window.addEventListener('rate-limit-exceeded', handleRateLimit);
    
    return () => {
      window.removeEventListener('rate-limit-exceeded', handleRateLimit);
      clearTimeout(timeoutId);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed top-6 left-1/2 transform -translate-x-1/2 z-[9999] animate-in slide-in-from-top-4 fade-in duration-300">
      <div className="bg-white/95 backdrop-blur-md border border-red-100 shadow-xl rounded-xl p-4 flex items-start gap-4 max-w-sm w-[90vw]">
        <div className="flex-shrink-0 pt-0.5">
          <div className="h-8 w-8 rounded-full bg-red-50 flex items-center justify-center">
            <ShieldAlert className="h-5 w-5 text-red-500" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-900 mb-1">
            Requests Paused
          </h3>
          <p className="text-sm text-gray-500 leading-snug">
            For your security, we've paused your requests. Please wait a moment before trying again.
          </p>
        </div>
        <button 
          onClick={() => setIsVisible(false)}
          className="flex-shrink-0 ml-2 rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
